import React, { useEffect, useState } from 'react';
import './ContactUs.css';
import { FaFacebookF, FaYoutube, FaEnvelope } from 'react-icons/fa';
import { Helmet } from 'react-helmet';
import axios from 'axios';

const ContactUs = () => {
  const [metaTags, setMetaTags] = useState([]);

  useEffect(() => {
    const fetchMetaTags = async () => {
      try {
        const res = await axios.get('https://api.funfillia.com/api/website/metaTags/contact_us', {
          headers: {
            Accept: 'application/json',
            'Client-Domain': 'www.clevercoverageofficial.com',
          },
        });

        const htmlString = res.data?.metaTags || '';
        const doc = new DOMParser().parseFromString(htmlString, 'text/html');
        const tags = Array.from(doc.head.children);
        setMetaTags(tags);
      } catch (err) {
        console.error("Failed to fetch meta tags for Contact Us page", err);
      }
    };

    fetchMetaTags();
  }, []);

  const getMetaContent = (attr, value) => {
    const tag = metaTags.find(t => t.getAttribute(attr) === value);
    return tag?.getAttribute('content') || '';
  };

  return (
    <>
      <Helmet>
        <title>Contact Us - Clever Coverage</title>

        {/* General Meta Tags */}
        <meta name="title" content={getMetaContent('name', 'title')} />
        <meta name="description" content={getMetaContent('name', 'description')} />
        <meta name="keywords" content={getMetaContent('name', 'keywords')} />
        <link rel="canonical" href={window.location.href} />

        {/* Open Graph / Facebook Meta Tags */}
        <meta property="og:type" content={getMetaContent('property', 'og:type')} />
        <meta property="og:url" content={getMetaContent('property', 'og:url')} />
        <meta property="og:title" content={getMetaContent('property', 'og:title')} />
        <meta property="og:description" content={getMetaContent('property', 'og:description')} />
        <meta property="og:image" content={getMetaContent('property', 'og:image')} />

        {/* Twitter Meta Tags */}
        <meta name="twitter:card" content={getMetaContent('name', 'twitter:card')} />
        <meta name="twitter:url" content={getMetaContent('name', 'twitter:url')} />
        <meta name="twitter:title" content={getMetaContent('name', 'twitter:title')} />
        <meta name="twitter:description" content={getMetaContent('name', 'twitter:description')} />
        <meta name="twitter:image" content={getMetaContent('name', 'twitter:image')} />
      </Helmet>

      <div className="contact-container">
        <div className="contact-card">
          <h2>Contact Us</h2>
          <p>We'd love to hear from you! Whether it's a question, suggestion, or feedback, feel free to reach out.</p>
          <div className="contact-info">
            <div className="contact-item">
              <FaEnvelope className="icon" />
              <a href="mailto:info@clevercoverageofficial.com">info@clevercoverageofficial.com</a>
            </div>
            <div className="contact-item">
              <FaFacebookF className="icon" />
              <a href="https://www.facebook.com/profile.php?id=61573830460950" target="_blank" rel="noopener noreferrer">Facebook Page</a>
            </div>
            <div className="contact-item">
              <FaYoutube className="icon" />
              <a href="https://www.youtube.com/@CleverCoverage" target="_blank" rel="noopener noreferrer">YouTube Channel</a>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ContactUs;
